module.exports = __webpack_public_path__ + "static/media/keepRight.e2859602.svg";